module.exports = __webpack_public_path__ + "static/media/local_pharmacy_header.6ad203cc.svg";